import { Component, OnInit, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';

@Component({
    selector: 'app-order-details-dashboard',
    templateUrl: './order-details-dashboard.component.html',
    styleUrls: ['./order-details-dashboard.component.scss'],
    standalone: false
})

export class OrderDetailsDashboardComponent implements OnInit {
  @ViewChild('calendar') calendar: any;
  states: any;
  selectedState:any;
  rangeDates: Date[] =[];
 selectedDate = new Date();
  totalOrders :number = 100;
 inprogressOrders: number = 29;
 completedOrders: number = 66;
 canceledOrder:number = 3;
 incrementValue: boolean = true;
 displayBranch! : any ;
 maxDate= new Date();

  constructor(private userDashboardService:UserDashboardService,private storageService:StorageService,private cookieService: CookieService) { 
    this.userDashboardService.getBranchList().subscribe((res:any)=>{
      this.states = res['content'];
      this.displayBranch = this.storageService.getBranch() || null;
      this.displayBranch = this.displayBranch.name;
     
  })
  

  }

  ngOnInit(): void {
  }

  filterState(event:any){
  }
  getSelected(){
    this.cookieService.set('BranchName', this.selectedState);
  this.storageService.setBranch(this.selectedState)
  }
  onSelect(){
    if (this.rangeDates[1]) { 
      this.calendar.overlayVisible=false;
  }
}
}
